<template lang="pug">
  span(:style="{'background-image': 'url('+src+')', 'width': width, 'height': height}")
</template>

<style lang="scss" scoped>
span {
  background-size: cover;
  border-radius: 50%;
  display: inline-block;
  background-position: 50%;
  background-repeat: no-repeat;
}
</style>

<script>
const purposeTypes = {
  chat: { width: '80px', height: '80px' },
  list: { width: '51px', height: '51px' },
  profile: { width: '80px', height: '80px' },
  receiver: { width: '32px', height: '32px' },
  coach_profile: { width: '120px', height: '120px' },
}

export default {
  props: {
    src: { type: String, default: '' },
    purpose: {
      default: 'list',
      validator: function (value) {
        return Object.keys(purposeTypes).indexOf(value) !== -1
      },
    },
  },
  computed: {
    width: function () {
      return purposeTypes[this.purpose].width
    },
    height: function () {
      return purposeTypes[this.purpose].height
    },
  },
}
</script>
